// extracted by mini-css-extract-plugin
export default {"label":"styles_label__NqfCm","labelFeature":"styles_labelFeature__xC-G8"};